// extracted by mini-css-extract-plugin
module.exports = {"escapeUrl":"view-plans_escapeUrl_1Bc1w"};